import { createFileRoute } from '@tanstack/react-router'
import { CommunicationChannelsPage } from '@/pages/communication-channels/communication-channels-page'

export const Route = createFileRoute('/settings/communications')({
  component: CommunicationChannelsPage,
})
